import { h, formatDate, formatTime, formatDuration } from '../ui/dom.js';
import {
  card,
  button,
  table,
  emptyState,
  readinessBadge,
  metric,
  badge,
} from '../ui/components.js';
import { api } from '../api.js';
import type { Page, PageContext } from '../page.js';
import type { EditionMinistration } from '../types.js';

export async function myMinistrationsPage(context: PageContext): Promise<Page> {
  const { items } = await api.get<{ items: EditionMinistration[] }>('/api/my/ministrations');

  const pendentes = items.filter((item) => item.readiness !== 'HOMOLOGADO').length;
  const comMaterial = items.filter((item) => item.mediaCount > 0).length;

  const rows = items.map((item) => [
    h(
      'div',
      { class: 'stack stack--sm' },
      h('div', { style: { fontWeight: '600' }, text: item.title }),
      h('div', { class: 'muted small', text: item.editionName ?? 'Edição' }),
    ),
    h(
      'div',
      null,
      h('div', { class: 'mono', text: formatDate(item.scheduledStart) }),
      h('div', { class: 'muted small', text: `${formatTime(item.scheduledStart)} — ${formatTime(item.scheduledEnd)}` }),
    ),
    h('div', { text: formatDuration(item.durationMin) }),
    h('div', null, readinessBadge(item.readiness)),
    h('div', null, item.mediaCount > 0 ? badge(`${item.mediaCount} material(is)`, 'info') : badge('Sem material', 'neutral')),
    h(
      'div',
      { class: 'table__actions' },
      button(`Materiais / mídias${item.mediaCount > 0 ? ` (${item.mediaCount})` : ''}`, {
        size: 'sm',
        variant: item.mediaCount > 0 ? 'subtle' : 'ghost',
        onClick: () => context.navigate(`/ministracoes/${item.id}`),
      }),
      button('Modo Púlpito', {
        size: 'sm',
        variant: 'subtle',
        onClick: () => context.navigate(`/ministracoes/${item.id}/pulpito`),
      }),
    ),
  ]);

  return {
    title: 'Minhas Ministrações',
    subtitle: 'Escalas designadas a você, com roteiros e materiais de apoio.',
    body: [
      h(
        'div',
        { class: 'grid grid--3' },
        metric('Ministrações', items.length, 'accent'),
        metric('Aguardando homologação', pendentes, pendentes > 0 ? 'warning' : 'success'),
        metric('Com material anexado', comMaterial, 'info'),
      ),
      card({
        title: 'Escalas designadas',
        hint: 'Você pode editar o roteiro pessoal e anexar materiais sem alterar o modelo oficial.',
        body:
          items.length > 0
            ? table(['Ministração', 'Data e hora', 'Duração', 'Status', 'Materiais', ''], rows)
            : emptyState(
                'Você ainda não foi escalado. Assim que a coordenação designar uma ministração, ela aparecerá aqui.',
                '✦',
              ),
      }),
    ],
  };
}
